export var EMPTY_MENU = Object.freeze({
    sections: [],
    items: [],
    chargesV2: [],
});
export var EMPTY_ADDRESS = Object.freeze({
    formatted: '',
    latLng: {
        lat: 0,
        lng: 0,
    },
});
export var EMPTY_RESTAURANT = Object.freeze({
    type: 'restaurant',
    id: '',
    externalIds: {},
    created: 0,
    modified: 0,
    title: { en_US: '' },
    description: {},
    contact: { email: '', phone: '' },
    address: EMPTY_ADDRESS,
    timezone: '',
    currency: '',
    locale: '',
    locales: [''],
    properties: {},
    media: {},
    distributorId: '',
    openTimes: {},
    deliveryInfos: [],
    paymentTypes: [],
    creditcardsInfo: { networks: [], fields: [], comment: {} },
    deliveriesInfo: { approximateAddresses: 'allow' },
    orders: {
        availability: {},
        asap: { preOrderMins: 0 },
        future: { disabled: false, delayMins: { min: 0, max: 0 } },
        properties: {},
    },
    reservations: {
        pendingApproval: true,
        partySize: { min: 0, max: 0 },
        availability: {},
        futureDelayMins: { min: 0, max: 0 },
        heldForMins: 0,
        properties: {},
    },
});
export var EMPTY_CONTACT = Object.freeze({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
});
export var Modals;
(function (Modals) {
    Modals["DISH_MODAL"] = "DISH_MODAL";
    Modals["ORDER_SUBMITTED_MODAL"] = "ORDER_SUBMITTED_MODAL";
    Modals["ORDER_FAILURE_MODAL"] = "ORDER_FAILURE_MODAL";
    Modals["DISPATCH_SETTINGS_MODAL"] = "DISPATCH_SETTINGS_MODAL";
    Modals["CART_MODAL"] = "CART_MODAL";
    Modals["TERMS_AND_CONDITIONS"] = "TERMS_AND_CONDITIONS";
    Modals["PRIVACY_POLICY"] = "PRIVACY_POLICY";
})(Modals || (Modals = {}));
export var Screens;
(function (Screens) {
    Screens["INITIAL_VIEW"] = "INITIAL_VIEW";
    Screens["CHECKOUT_FLOW"] = "CHECKOUT_FLOW";
    Screens["THANK_YOU"] = "THANK_YOU";
})(Screens || (Screens = {}));
export var NO_ADDRESS = '[noskip]';
export var DEFAULT_ADDRESS = '500 Terry A Francois Boulevard, San Francisco, CA 94158, United States number = 500';
export var DEFAULT_ADDRESS_SHORT = '500 Terry Francois Street, San Francisco, CA, USA';
export var DISPATCH_MODAL_IN_OOI_QUERY_PARAM = 'dispatchType';
export var ErrorCodes;
(function (ErrorCodes) {
    ErrorCodes[ErrorCodes["CURBSIDE_PICKUP_UNAVAILABLE"] = 7006] = "CURBSIDE_PICKUP_UNAVAILABLE";
    ErrorCodes[ErrorCodes["PICKUP_UNAVAILABLE"] = 1002] = "PICKUP_UNAVAILABLE";
    ErrorCodes[ErrorCodes["DELIVERY_UNAVAILABLE"] = 1001] = "DELIVERY_UNAVAILABLE";
    ErrorCodes[ErrorCodes["PRICE_UPDATE"] = 1003] = "PRICE_UPDATE";
    ErrorCodes[ErrorCodes["PROMO_CODE_UPDATE"] = 1004] = "PROMO_CODE_UPDATE";
    ErrorCodes[ErrorCodes["DISCOUNT_UPDATE"] = 1006] = "DISCOUNT_UPDATE";
    ErrorCodes[ErrorCodes["VARIATION_PRICE_UPDATE"] = 1013] = "VARIATION_PRICE_UPDATE";
    ErrorCodes[ErrorCodes["TOGGLE_OFF_CHARGE"] = 2017] = "TOGGLE_OFF_CHARGE";
    ErrorCodes[ErrorCodes["INVALID_USER_CONTACT_DETAILS"] = 3000] = "INVALID_USER_CONTACT_DETAILS";
    ErrorCodes[ErrorCodes["INVALID_USER_LAST_NAME_DETAILS"] = 3001] = "INVALID_USER_LAST_NAME_DETAILS";
    ErrorCodes[ErrorCodes["INVALID_USER_FIRST_NAME_DETAILS"] = 3002] = "INVALID_USER_FIRST_NAME_DETAILS";
    ErrorCodes[ErrorCodes["INVALID_USER_PHONE_DETAILS"] = 3003] = "INVALID_USER_PHONE_DETAILS";
    ErrorCodes[ErrorCodes["INVALID_USER_COMMUNICATION_DETAILS"] = 3004] = "INVALID_USER_COMMUNICATION_DETAILS";
    ErrorCodes[ErrorCodes["RESTAURANTS_CLOSED"] = 5002] = "RESTAURANTS_CLOSED";
    ErrorCodes[ErrorCodes["DINE_IN_UNAVAILABLE"] = 10001] = "DINE_IN_UNAVAILABLE";
    ErrorCodes[ErrorCodes["DINE_IN_AND_CURBSIDE_HAVE_BEEN_SUBMITTED"] = 9001] = "DINE_IN_AND_CURBSIDE_HAVE_BEEN_SUBMITTED";
    ErrorCodes[ErrorCodes["ORDER_PRICE_BELOW_MIN_PICKUP_ORDER_PRICE"] = 9002] = "ORDER_PRICE_BELOW_MIN_PICKUP_ORDER_PRICE";
    ErrorCodes[ErrorCodes["DINE_IN_MISSING_LABEL"] = 10003] = "DINE_IN_MISSING_LABEL";
    ErrorCodes[ErrorCodes["DINE_IN_MISSING_LABEL_VALUE"] = 10002] = "DINE_IN_MISSING_LABEL_VALUE";
    ErrorCodes[ErrorCodes["DELIVERY_TIME_IS_LESS_THEN_DELIVETY_DURATION"] = 1016] = "DELIVERY_TIME_IS_LESS_THEN_DELIVETY_DURATION";
    ErrorCodes[ErrorCodes["DELIVERY_TIME_IS_MORE_THEN_MAX_DELIVETY_DURATION"] = 1017] = "DELIVERY_TIME_IS_MORE_THEN_MAX_DELIVETY_DURATION";
    ErrorCodes[ErrorCodes["DELIVERY_TIME_CANNOT_PRECEDE"] = 1018] = "DELIVERY_TIME_CANNOT_PRECEDE";
    ErrorCodes[ErrorCodes["LOYALTY_MISSING_REQUIRED_FIELD"] = 8001] = "LOYALTY_MISSING_REQUIRED_FIELD";
    ErrorCodes[ErrorCodes["LOYALTY_FEATURE_CLOSED"] = 8002] = "LOYALTY_FEATURE_CLOSED";
    ErrorCodes[ErrorCodes["LOYALTY_INSUFFICIENT_BALANCE"] = 8003] = "LOYALTY_INSUFFICIENT_BALANCE";
    ErrorCodes[ErrorCodes["LOYALTY_INVALID_POINTS_AMOUNT"] = 8004] = "LOYALTY_INVALID_POINTS_AMOUNT";
    ErrorCodes[ErrorCodes["LOYALTY_REWARD_NOT_ACTIVE"] = 8005] = "LOYALTY_REWARD_NOT_ACTIVE";
    ErrorCodes[ErrorCodes["LOYALTY_UNSUPPORTED_DISCOUNT_TYPE"] = 8006] = "LOYALTY_UNSUPPORTED_DISCOUNT_TYPE";
    ErrorCodes[ErrorCodes["LOYALTY_POINTS_REQUIRED"] = 8007] = "LOYALTY_POINTS_REQUIRED";
    ErrorCodes[ErrorCodes["LOYALTY_UNEXPECTED_CHARGES_AMOUNT"] = 8008] = "LOYALTY_UNEXPECTED_CHARGES_AMOUNT";
    ErrorCodes[ErrorCodes["LOYALTY_FAILED_TO_REDEEM_POINTS"] = 8009] = "LOYALTY_FAILED_TO_REDEEM_POINTS";
})(ErrorCodes || (ErrorCodes = {}));
//# sourceMappingURL=constants.js.map